import React, { useState } from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ImageWithFallback from "components/ImageWithFallback/ImageWithFallback";
import { formatPrice } from "utilities/menuItemUtils";

type Props = {
    title: string;
    image?: string | null;
    price: number;
    addToCart: () => void;
};

const UpsellItem: React.FC<Props> = ({
                                   title,
                                   image,
                                   price,
                                   addToCart,
                               }) => {
    const [isItemClickable, setIsItemClickable] = useState(true);
    const handleClick = () => {
        addToCart();
        setIsItemClickable(false);
        setTimeout(() => {
            setIsItemClickable(true);
        }, 2000);
    };
    return (
            <button
                type="button"
                className="upsell-item"
                onClick={handleClick}
                disabled={!isItemClickable}
                aria-label="click to add item"
            >
                <ImageWithFallback
                    src={image}
                    alt={title}
                />
                <p className="upsell-item-title">
                    {title}
                </p>
                <p className="upsell-item-price">
                    {price > 0 && (
                        <>
                            &nbsp;
                            $
                            {formatPrice(price)}
                        </>
                    )}
                </p>
                <p className={`upsell-item-button ${isItemClickable ? '' : 'upsell-button-disabled'}`}>
                    {isItemClickable ? (
                        <>
                            ADD
                        </>
                    ) : (
                        <>
                            ADDED
                            <CheckRoundedIcon fontSize="small" className="upsell-button-disabled"/>
                        </>
                    )}
                </p>
            </button>
    );
};
export default UpsellItem;
